import { render, staticRenderFns } from "./MachineHeader.component.vue?vue&type=template&id=1ffc857a&scoped=true&"
import script from "./MachineHeader.component.vue?vue&type=script&lang=ts&"
export * from "./MachineHeader.component.vue?vue&type=script&lang=ts&"
import style0 from "./MachineHeader.component.vue?vue&type=style&index=0&id=1ffc857a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffc857a",
  null
  
)

export default component.exports